module.exports = __webpack_public_path__ + "static/swim-b13c3947bd79608299f3715fbbb9cf69.mp4";